/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-shadow
export enum StepStatus {
  DONE = 'done',
  PROGRESS = 'progress',
  FAILED = 'failed',
  PENDING = 'pending',
}

export type BeerStepStatusType = 'done' | 'progress' | 'failed' | 'pending'
